// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'mail-plus';

export const Component = () => (
  <path d='M18.152 7.89H1.485c-.623 0-1.101.287-1.389.91C.048 8.991 0 13.11 0 21.156c0 .431.144.767.431 1.054.288.288.623.431 1.054.431h16.667c.43 0 .766-.143 1.053-.43a1.41 1.41 0 0 0 .432-1.055c0-7.998-.048-12.117-.144-12.356-.288-.623-.719-.91-1.34-.91h-.001Zm.478 3.592v9.674c0 .335-.143.48-.478.48H1.485c-.335 0-.526-.145-.526-.48v-9.674l7.806 4.98c.287.192.622.288 1.054.288.431 0 .766-.096 1.054-.288l7.758-4.98Zm0-2.107v.958l-8.285 5.316c-.143.096-.287.144-.526.144a.963.963 0 0 1-.527-.144L.96 10.333v-.958c0-.335.191-.479.526-.479h16.667c.335 0 .478.144.478.479Zm5.412-4.406c.335 0 .48.143.48.479 0 .335-.145.479-.48.479H21.6v2.49c0 .335-.191.48-.527.48-.335 0-.478-.145-.478-.48v-2.49h-2.443c-.335 0-.479-.144-.479-.48 0-.335.144-.478.48-.478h2.442V2.527c0-.336.143-.527.478-.527.336 0 .527.191.527.527v2.442h2.442Z' />
);

export const viewBox = '0 0 25 25';
